<template>

  <div class="map-sidebar" :class="{ collapsed: collapsed }">
    <div class="toggler" @click="collapsed = !collapsed">
      <v-icon v-if="collapsed">keyboard_arrow_left</v-icon>
      <v-icon v-if="!collapsed">keyboard_arrow_right</v-icon>
    </div>

    <div class="sidebar-content">
      <tabs v-if="!info"></tabs>
      <element-info v-if="info"></element-info>
    </div>
  </div>

</template>

<script>

import { mapState } from 'vuex'
import Tabs from './tabs.vue'
import ElementInfo from './element-info.vue'

export default {
  name: 'sidebar',

  data () {
    return {
      collapsed: false,
      show: false,
      reason: String
    }
  },

  computed: {
    ...mapState('map', [
      'selected',
      'locked'
    ]),

    info () {
      return this.selected && this.selected.assetId
    }
  },
  methods: {

  },
  watch: {
    selected () {
      this.collapsed = false
    }
  },

  components: {
    Tabs,
    ElementInfo
  }
}

</script>

<style lang="scss" scoped>

  @import '../../../assets/responsive';

  $background-color: #FFFFFF;
  $border: darken($background-color, 10%);

  @mixin heading {
    background-color: #f8f8f8;
    border-bottom: 1px solid #DDD;
  }

  .map-sidebar {
    position: relative;
    flex: 1 1 500px;
    width: 0;
    background-color: $background-color;
    border-left: 1px solid $border;
    box-shadow: 0px 0px 15px 0px rgba(50, 50, 50, 0.6);
    z-index: 0;
    transition: all .2s ease-in;
    transition-property: flex-basis, top;

    .sidebar-content {
      min-height: 100%;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      overflow-y: auto;
    }

    &.collapsed {
      flex-basis: 0px;
    }

    .toggler {
      $size: 25px;
      $radius: 5px;

      position: absolute;
      display: flex;
      background-color: $background-color;
      border: 1px solid darken($border, 20%);
      border-right: none;
      border-top-left-radius: $radius;
      border-bottom-left-radius: $radius;
      top: calc(50% - 25px);
      left: -$size;
      width: $size;
      height: $size * 2;
      cursor: pointer;
    }

    @include media('<tablet') {
      position: absolute;
      left: 0;
      top: 20vh;
      bottom: 0;
      right: 0;
      width: 100%;

      .toggler {
        top: 0;
        left: calc(50% - 14px);
        transform: rotate(90deg) translateX(-37px);
    }

    &.collapsed {
      top: 100%;

      ::v-deep .v-tabs-slider-wrapper {
        display: none;
      }
    }
  }
}
</style>
